import { Outlet } from 'react-router-dom';

const Layout = () => {
    // Outlet represent all  the children of layout component
    // const { auth } = useAuth();
    // const {RedirectRoleAndFromBased} = useAuthSetState();
    // useEffect(() => {
    //     if(auth?.roles){
    //         // ! we could do this redirection inside Layout.js (here), and also we could do it inside :  in (Persist login) after getting the proper user data which is I prefer
    //         // finally {
    //         //     //? isMounted &&
    //         //     setIsLoading(false);
    //         // }
    //         RedirectRoleAndFromBased({role: auth?.roles});
    //     }
    // }, []);

    return (
        <div className="App">
            <Outlet />
            {/* <Footer /> */}
        </div>
    );
};

export default Layout;